var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"12"}},[_c('b-card',[_c('vue-apex-charts',{attrs:{"type":"area","height":"400","options":_vm.options,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }